import { IGovernmentProjectDetailResponse } from '../../../model/base/response/government-project-response';

export type GovernmentProjectDetailState = {
    detail: IGovernmentProjectDetailResponse | null;
    loading: boolean;
    error: string | null;
};

export enum ACTION_TYPES {
    setDetail = 'setDetail',
    setLoading = 'setLoading',
    setError = 'setError',
}

export const GovernmentProjectDetailReducer = (state: GovernmentProjectDetailState, action: any): GovernmentProjectDetailState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.setDetail:
            return {
                ...state,
                detail: payload,
                loading: false,
                error: null,
            };
        case ACTION_TYPES.setLoading:
            return {
                ...state,
                loading: payload,
            };
        case ACTION_TYPES.setError:
            return {
                ...state,
                error: payload,
                loading: false,
            };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
}
